var _line, _line2, _line3, _line4, _path, _line5, _line6, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.30435,
    y1: 10,
    x2: 1.30435,
    y2: 0.00000766062,
    stroke: "white",
    strokeWidth: 1.3913
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.43489,
    y1: 10,
    x2: 3.43489,
    y2: 0.00000764501,
    stroke: "white",
    strokeWidth: 0.695652
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.2176,
    y1: 10,
    x2: 6.2176,
    y2: 0.00000764501,
    stroke: "white",
    strokeWidth: 0.695652
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.65249,
    y1: 10,
    x2: 8.65249,
    y2: 0.00000766062,
    stroke: "white",
    strokeWidth: 1.3913
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4346 10L11.4346 7.62939e-06",
    stroke: "white",
    strokeWidth: 0.695652
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.7825,
    y1: 10,
    x2: 11.7825,
    y2: 0.00000764501,
    stroke: "white",
    strokeWidth: 0.695652
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 14.2174,
    y1: 10,
    x2: 14.2174,
    y2: 0.00000766062,
    stroke: "white",
    strokeWidth: 1.3913
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10L17 7.62939e-06",
    stroke: "white",
    strokeWidth: 0.695652
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcode);
export default __webpack_public_path__ + "static/media/icon_barcode.99c8158c3934d416b4870a79c18e50c4.svg";
export { ForwardRef as ReactComponent };